module.exports = __webpack_public_path__ + "img/programme5.b5a20c14.png";